
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-tour",
      function () {
        return require("private-next-pages/product-tour.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-tour"])
      });
    }
  